<div class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4 font">
  <div class="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center transform hover:scale-105 transition-all duration-300">

    <!-- Cancel Icon -->
    <div class="mb-6">
      <div class="mx-auto w-20 h-20 bg-red-100 rounded-full flex items-center justify-center animate-pulse">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="lucide lucide-x-circle w-12 h-12 text-red-600">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      </div>
    </div>

    <!-- Title & Subtitle -->
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-gray-900 mb-4 leading-tight">{{ 'VALUES.THANK_YOU' | translate }}</h1>
      <p class="text-lg text-gray-700 leading-relaxed mb-6">{{ 'VALUES.PAYMENT_CANCELLED' | translate }}</p>
      <div class="w-16 h-1 bg-red-500 mx-auto rounded-full"></div>
    </div>

    <!-- Info / Details -->
    <div class="space-y-4 mb-8">
      <div class="flex items-center justify-center space-x-3 text-gray-600">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="lucide lucide-alert-circle w-5 h-5 text-red-500">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12" y2="16"></line>
        </svg>
        <span class="text-sm">{{ 'VALUES.PAYMENT_CANCELLED_INFO' | translate }}</span>
      </div>
    </div>

    <!-- Next Steps Box -->
    <div class="bg-red-50 rounded-xl p-6 border border-red-100">
      <p class="text-gray-700 text-sm leading-relaxed">{{ 'VALUES.PAYMENT_CANCELLED_NEXT_STEPS' | translate }}</p>
    </div>

    <!-- Footer / Appreciation -->
    <div class="mt-8 pt-6 border-t border-gray-100">
      <p class="text-xs text-gray-500">{{ 'VALUES.APPRECIATION' | translate }}</p>
    </div>
  </div>

  <!-- Background Shapes -->
  <div class="fixed inset-0 -z-10 overflow-hidden">
    <div class="absolute top-1/4 left-1/4 w-32 h-32 bg-red-200 rounded-full opacity-20 animate-pulse"></div>
    <div class="absolute bottom-1/4 right-1/4 w-24 h-24 bg-red-300 rounded-full opacity-15 animate-pulse delay-1000"></div>
    <div class="absolute top-3/4 left-1/3 w-16 h-16 bg-red-400 rounded-full opacity-10 animate-pulse delay-2000"></div>
  </div>
</div>
